import { HttpErrorsType } from '../../application/protocols/http-client';
import { type DomainException } from './domain-exception';

export class UserAlreadyExistsException implements DomainException {
  message = HttpErrorsType.USER_ALREADY_EXISTS_EXCEPTION;
  code = 'Error';
}
